module.exports = __webpack_public_path__ + "img/slots12.040d5224.jpg";